import { useSelector } from "react-redux";
import {
  getCharacterFighterData,
  getOpponentFighterData,
  getOpponentPilotSkills,
  getOpponentSkillsFightInfo,
} from "redux/selectors/fightSelectors";
import styled, { css } from "styled-components";
import SkillIcon from "./SkillIcon";
import { media } from "components/styles/breakpoints";

const SkillsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 5px;
  max-height: 100px;
  justify-content: flex-end;

  ${media.desktop`
    max-height: 150px;
  `}
`;

const disabledMixin = css`
  opacity: 0.5;
  cursor: auto;
  filter: saturate(0);
`;

const SkillWrapper = styled.div<{ $isDisabled: boolean }>`
  width: 24px;
  font-size: 14px;
  aspect-ratio: 1/1;

  ${(props) => props.$isDisabled && disabledMixin}

  ${media.desktop`
  width: 32px;
  font-size: 18px;
  `}
`;

export default function OpponentSkills() {
  const characterFighter = useSelector(getCharacterFighterData);
  const opponentFighter = useSelector(getOpponentFighterData);
  const skills = useSelector(getOpponentPilotSkills);
  const { skillsRecharge } = useSelector(getOpponentSkillsFightInfo);

  return (
    <SkillsWrapper>
      {skills.map((skill) => {
        const rechargeTurns = skillsRecharge[skill.slug] || 0;
        const totalRecharge = skill.recharge || rechargeTurns;
        const rechargePercentage = (rechargeTurns / totalRecharge) * 100;
        const isRecharging = rechargeTurns > 0;

        return (
          <SkillWrapper $isDisabled={isRecharging} key={skill.slug}>
            <SkillIcon
              skill={skill}
              attacker={opponentFighter}
              defender={characterFighter}
              isShowValues
              isRecharging={isRecharging}
              rechargeTurns={rechargeTurns}
              rechargePercentage={rechargePercentage}
            />
          </SkillWrapper>
        );
      })}
    </SkillsWrapper>
  );
}
